import React from 'react';

import BaseLayout from '../../layouts/base-layout';
import CollectionsGrid from '../../components/collections/collections-grid';
import HeadWrapper from '../../components/layout/head-wrapper';
import PageTitle from '../../components/common/page-title';
import Pagination from '../../components/common/pagination';
import TaxonomyBar from '../../components/collections/taxonomy-bar';

const subtitleForThisPage = (pageContext) => {
    const { mediaGroup, taxonomyCategory, taxonomyFilter } = pageContext;

    if (!taxonomyCategory) {
      return `Medium: ${mediaGroup}`
    }

    return `Medium: ${mediaGroup} – ${taxonomyCategory}: ${taxonomyFilter}`;
};

export const Head = ({ pageContext }) => (
	<HeadWrapper
		title={`${subtitleForThisPage(pageContext)} — Collections`}
	>
		<meta
			id="metaTitle"
			name="title"
			content={`${subtitleForThisPage(pageContext)} — Collections`}
		/>
		<meta
			id="ogTitle"
			property="og:title"
			content={`${subtitleForThisPage(pageContext)} — Collections`}
		/>
		<meta
			id="ogUrl"
			property="og:url"
			content={(pageContext.page > 1) ? (
				`https://publicdomainreview.org/collections/${pageContext.taxonomyPath}/${pageContext.page}/`
			) : (
				`http://publicdomainreview.org/collections/${pageContext.taxonomyPath}/`
			)}
		/>
	</HeadWrapper>
);

class CollectionTaxonomyView extends React.Component {
  constructor(props) {
    super(props);

    this.collectionsForThisPage = this.collectionsForThisPage.bind(this);
  }

  collectionsForThisPage() {
    const start = (this.props.pageContext.page - 1) * this.props.pageContext.perPage;

    return this.props.pageContext.collectionsData.slice(start, start + this.props.pageContext.perPage);
  }

  render() {
    const { mediaGroup, taxonomyCategory } = this.props.pageContext;

    return (
      <BaseLayout path={this.props.location.pathname}>
        <div className="page-width">
          <aside aria-label="Current View Title">
            <PageTitle
              title="Collections"
              subtitle={subtitleForThisPage(this.props.pageContext)}
            />
          </aside>

          <TaxonomyBar
            mediaContext={ mediaGroup }
            filterContext={ taxonomyCategory }
            position="Top"
          />
        </div>


        <main>
          <div className="section-spaced-row page-width">
            <CollectionsGrid collections={ this.collectionsForThisPage() } />
          </div>
  
          {(this.props.pageContext.totalPages > 1) ? (
            <div className="page-width">
              <Pagination
                basePath={`/collections/${this.props.pageContext.taxonomyPath}`}
                currentPage={this.props.pageContext.page}
                numPages={this.props.pageContext.totalPages}
              />
            </div>
          ) : null}
        </main>

          <div className="page-width">
            <TaxonomyBar
              mediaContext={ mediaGroup }
              filterContext={ taxonomyCategory }
              position="Bottom"
            />
          </div>
      </BaseLayout>
    );
  }
}

export default CollectionTaxonomyView;
